import Vue from "vue";

import Export2Excel from "@/components/Export2Excel.vue";

Vue.component("export-2-excel", Export2Excel);
